import { normalizeCheckout } from "./normalizeCheckout";

// The discount is subtracted from the base price and the installment interest is
// recalculated over it, so the prices come already discounted from the API
// (POST checkout/:id/validate_discount) instead of being recomputed here.
export const buildDiscountedCheckout = (checkout, discount) =>
  normalizeCheckout({
    ...checkout,
    installments: discount?.installments ?? checkout?.installments,
    checkout_payment_types_available:
      discount?.checkout_payment_types_available ??
      checkout?.checkout_payment_types_available,
  });
